// Income from served units, fuel cost for thermal units produced, daily fuel ramp.
import type { DispatchResult } from './dispatch';
import type { Balance, World } from './types';

export function applyEconomy(world: World, dispatch: DispatchResult, balance: Balance): void {
  world.cash += dispatch.totalServed * balance.economy.pricePerUnit;
  world.cash -= dispatch.thermalUnits * world.fuelPrice;
}

export function rampFuelPrice(world: World, growthPerDay: number): void {
  world.fuelPrice *= 1 + growthPerDay;
}
